import { NgClass } from "@angular/common";
import { Component, Input } from "@angular/core";
import { SvgIcon, SvgIconMap } from "@ponder-shared/utils/svgIcons";

@Component({
    selector: "busy-spin",
    imports: [NgClass],
    templateUrl: "./busy-spin.component.html"
})
export class BusySpinComponent {
    @Input() public small: boolean = false;
    @Input() public bright: boolean = false;

    public readonly busySpinSvg = SvgIconMap.get(SvgIcon.BusySpin)!;
}